import axios from 'axios';

export default axios.create({
    // baseURL: 'https://nomorevit.herokuapp.com'
    // // baseURL: 'http://localhost:3500'
});